import PageCourseNavigation from './PageCourseNavigation';

export default PageCourseNavigation;
export * from './PageCourseNavigation';
